import React from "react";
import { Input, List } from "antd";

import { useDraggable } from "@dnd-kit/core";
import { defaultSettings } from "css/defaultAntStyles";
const { TextArea } = Input;

export const MyListItem = ({ item, type, isDrag = false }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: item.id,
    data: {
      item,
      type,
    },
  });
  return (
    <List.Item
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={{
        opacity: isDragging ? 0 : 1,
        border: isDrag ? `2px solid ${defaultSettings.colorPrimary}` : "",
        borderRadius: isDrag ? `8px` : "",
      }}
    >
      {type === "works" ? (
        <TextArea
          style={{
            backgroundColor: "var(--main-custom-input-bg-color)",
            resize: "none",
            cursor: "move",
          }}
          autoSize={{ minRows: 1, maxRows: 15 }}
          value={`${item?.code}. ${item?.title}, ${item?.unit}`}
          disabled={true}
          readOnly
        />
      ) : (
        <div
          style={{
            display: "flex",
            gap: "15px",
            flexDirection: "row",
            width: "100%",
            cursor: "move",
          }}
        >
          <TextArea
            style={{
              backgroundColor: "var(--main-custom-input-bg-color)",
              resize: "none",
              cursor: "inherit",
            }}
            autoSize={{ minRows: 1, maxRows: 15 }}
            value={`${item?.dateArrived}. ${item?.nomenclature}, ${item?.unit}`}
            disabled={true}
            readOnly
          />

          <Input
            value={item?.restCount}
            disabled
            style={{ width: "80px", textAlign: "center", cursor: "inherit" }}
          />
        </div>
      )}
    </List.Item>
  );
};
